import React from 'react';

import Footer from 'components/Footer';
import Navbar from 'components/Nav';

const PublicPage = ({ navbarProps, children }) => (
  <>
  <div className="flex-wrapper has-background-grey-lighter">
  <Navbar {...navbarProps} />
  <section className="page p-5">
    {children}
  </section>
  <Footer />
  </div>
  </>
)

export default PublicPage;
